import { BehaviorSubject } from 'rxjs';

export abstract class ReportFilterChange {
    /**
     * Can be used to listen to changes
     */
    public change$ = new BehaviorSubject<boolean | null>(null);
}
